import { render, staticRenderFns } from "./NotificationCatcher.vue?vue&type=template&id=7b5b84bb&scoped=true&"
import script from "./NotificationCatcher.vue?vue&type=script&lang=js&"
export * from "./NotificationCatcher.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCatcher.vue?vue&type=style&index=0&id=7b5b84bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b84bb",
  null
  
)

export default component.exports